jQuery(document).ready(($) => {

    let $gallery = $('.post-gallery');

    if ($gallery.length) {

        $gallery.slick({
            'slidesToShow': 1,
            'slidesToScroll': 1,
            'infinite': true,
            'autoplay': true,
            'autoplaySpeed': 4000,
            'rtl': true,
            'dots': false,
            'adaptiveHeight': false,
            'lazyLoad': 'progressive',
            'nextArrow': '<img class="next" src="/app/themes/sport1/public/images/left-arrow.svg">',
            'prevArrow': '<img class="prev" src="/app/themes/sport1/public/images/right-arrow.svg">'
        });
    }
});